var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile flex flex-center flex-align"},[(_vm.user && _vm.user.profile_image_url)?_c('img',{attrs:{"src":_vm.user.profile_image_url}}):_c('div',{staticClass:"placeholder"})])
}
var staticRenderFns = []

export { render, staticRenderFns }